<template>
    <g-level>
        <g-level-item v-for="(item, index) in truncatedProductList" :key="`${item.id}_${index}`">
            <g-image-thumbnail
                :image-link="imageUrl(item)"
                :image-description="productName(item)"
                :image-height="41"
                :image-width="41"
                class="pdf-remove"
            />
        </g-level-item>
        <g-level-item v-if="truncateList" class="product-image-wrapper">
            <g-typography :value="truncatedCountString" tag="h4" />
        </g-level-item>
    </g-level>
</template>

<script>
    import { get } from 'lodash';

    export default {
        name: 'ProductImageList',
        props: {
            products: {
                type: Array
            }
        },
        computed: {
            availableList() {
                return this.products.filter((product) => !!product);
            },

            truncatedProductList() {
                if (this.truncateList) {
                    return this.availableList.slice(0, 6);
                }
                return this.availableList;
            },
            truncatedCountString() {
                if (this.truncateList) {
                    return `+${this.availableList.length - 6}`;
                }
                return null;
            },
            truncateList() {
                return this.availableList.length > 6;
            }
        },
        methods: {
            imageUrl(product) {
                if (get(product, 'image', false)) {
                    return product.image;
                }
                return 'https://d1igyfcg6nq1cr.cloudfront.net/placeholder/placeholder-square.jpg';
            },
            productName(product) {
                if (get(product, 'name', false)) {
                    return product.name;
                }
                return 'No product name';
            }
        }
    };
</script>
